<script setup lang="ts">
import {
    Collapsible,
} from '@/shadcn/components/ui/collapsible'

import { ref } from 'vue'

const isOpen = ref(false)
</script>

<template>
    <Collapsible
        v-model:open="isOpen"
    >
        <slot :open="isOpen" />
    </Collapsible>
</template>
